import { api, createCancelTokenHandler } from "../../vodea/services";

const endPoint = () => process.env.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (brandId: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/brand/${brandId}/widget/product/card/`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
  getGrossMargin: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/card/gross-margin`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getGrossMargin.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getSoldProduct: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/card/sold-product`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getSoldProduct.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getGrossMarginChart: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/chart/gross-margin-period`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getGrossMarginChart.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getSoldProductChart: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/chart/sold-product-period`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getSoldProductChart.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getTableData: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/table/performance`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getTableData.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getInStockRate: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/card/in-stock-rate`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getInStockRate.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getAvgInStockRate: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/card/average-in-stock-rate`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getAvgInStockRate.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getRunRate: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/card/average-run-rate`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.getRunRate.name
          ].handleRequestCancellation().token,
      }
    );
  },
  getWOS: function (brandId: number | string, params: any = null) {
    return api.get(
      `${endPoint()}/api/brand/${brandId}/widget/product/card/average-weeks-of-supply`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[this.getWOS.name].handleRequestCancellation()
            .token,
      }
    );
  },
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
